import { render } from "./AddPatientModal.vue?vue&type=template&id=144187c4&scoped=true"
import script from "./AddPatientModal.vue?vue&type=script&lang=js"
export * from "./AddPatientModal.vue?vue&type=script&lang=js"

import "./AddPatientModal.vue?vue&type=style&index=0&id=144187c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144187c4"]])

export default __exports__